// import Cookie from 'js-cookie'
const _ = require('lodash')
export const state = () => ({
  langList: [
    'ar', // 阿拉伯语
    'de', // 德语
    'en',
    'es',
    'fil',
    'fr', // 法语
    'hi', // 印地
    'id',
    'it', // 意大利
    'ja',
    'ko', // 韩语
    'pt', // 葡萄牙语
    'tr', // 土耳其
    'ru',
    'th',
    'vi',
    'zh',
    'zh-cn',
    'zh-hk',
    'zh-tw'
  ], // 国际版语言列表
  myCountry: '', // 用户所在的国家（不变的值）
  host: '', // 获取域名
  allHost: '', // 当前页面地址
  path: '', // 当前页面路径（不包含语言）
  LanguageCode: '', // 语言
  CountryCode: '', // 国家
  getCountry: {}, // 获取国家code，国家名称，国家代码，国旗
  cookieHost: '', // 处理好存cookie需要的路径域名
  userIp: '', // 用户ip
  mobile: false, // 是否为移动端pc---true；m站---false
  contentcookie: '', // 用户登录cookie值
  user: {}, // 用户登录信息userId--用户id；nick用户昵称；avatar--用户头像
  userInfo: {}, // 用户信息
  usergetCountry: {}, // 用户中心国家数据
  riskShow: false, // 风险提示是否展示
  menuData: [], // 菜单数据
  contactinfo: '', // 底部联系方式
  indexConfigure: [], // 首页配置
  footCountry: [], // 底部国家
  loginShow: false, // 登录框是否显示
  pluginShow: false, // chrome下载框是否显示
  linkFriend: [], // 友情链接
  partnerList: [], // 战略合作
  newhost: 'wikifx', // 特殊域名--保留主体部分
  suffix: 'com', // 域名后缀
  newsbool: false, // 是否为特殊域名
  loghost: 'http://192.168.200.151:8087', // 日志请求地址
  isWiki: '1', // (1:wikifx;2:包含fxeye；3:包含wikifxvn.com,wikifxvi.com,wikifxen.com)
  isSpecalFxeye: false, // fxeye中特殊的域名(推广用)
  fxeyepoint: {}, // fxeye点位配置
  livestate: {}, // 直播状态 1-进行中；2-未开始；3-已结束
  linkDom: '', // 页面底部外链dom
  nodeEnv: '', // 环境变量
  // 直播配置
  msgList: { // IM消息列表
    chatroom: {}
  },
  // 是否支持 webRTC
  isSupportWebRTC: true,
  // 线路选择-rtc|cdn|leb
  lineType: 'rtc',
  // 播放状态-playing(播放中)|paused(暂停)
  playState: 'paused',
  // sdkAppId
  sdkAppId: 1400638854,
  // userSig
  userSig: '',
  // 设置播放域名
  playerDomain: '162804.livepush.myqcloud.com',
  // 房间号信息
  roomId: null,
  // 直播间昵称
  roomName: '',
  // 主播用户id
  anchorUserId: '',
  liveuserInfo: {
    // 用户ID
    userId: `web_${Math.floor(Math.random() * 10000)}`,
    // 用户昵称
    userName: `观众${Math.floor(Math.random() * 10000)}`,
    // 用户头像
    userAvatar: ''
  },
  lang_speak: '', // 字幕
  lang_speak_lang: '', // 字幕语言
  layout: 'vertical', // 竖屏展示
  stop_show: true,
  isanchor: false,
  riskcontrol: {} // 屏蔽点位
})

export const mutations = {
  setlinkuser (state, value) {
    console.log('环境变量', state.mobile)
    // state.liveuserInfo.userId = state.user.userId ? '0_' + '999_' + (state.mobile ? '998_' : '0_') + '1_' + state.user.userId + '_' + ((Math.floor(Math.random() * 1000000)) + Array(6).join(0)).slice(0, 6) : '0_' + '999_' + (state.mobile ? '998_' : '0_') + '0_' + value + '_' + ((Math.floor(Math.random() * 1000000)) + Array(6).join(0)).slice(0, 6)
    state.liveuserInfo.userId = state.user.userId ? '0_' + '999_' + (state.mobile ? '998_' : '0_') + '1_' + state.user.userId + '_' + 3 + '_' + ((Math.floor(Math.random() * 1000000)) + Array(6).join(0)).slice(0, 6) : '0_' + '999_' + (state.mobile ? '998_' : '0_') + '0_' + value + '_' + 3 + '_' + ((Math.floor(Math.random() * 1000000)) + Array(6).join(0)).slice(0, 6)
    console.log('state.liveuserInfo: ', state.liveuserInfo)
  },
  setriskcontrol (state, value) {
    // 设置屏蔽点位
    Object.assign(state.riskcontrol, value)
  },
  setanchor (state, value) { // 直播是否开始直播
    state.isanchor = value
  },
  setNodeEnv (state, value) { // 获取环境变量
    state.nodeEnv = value || ''
  },
  set_stop_show (state, locale) {
    // 主播是否暂停
    state.stop_show = locale
  },
  setlinkDom (state, value) { // 设置页面底部外链dom
    state.linkDom = value
  },
  setLivestate (state, value) { // 获取直播状态
    // state.livestate = value
    Object.assign(state.livestate, value)
  },
  setFxeyepoint (state, value) { // 设置fxeye点位配置
    Object.assign(state.fxeyepoint, value)
  },
  setHost (state, value) { // 处理特殊域名
    state.newhost = value.host
    state.newsbool = value.bool
  },
  setsuffix (state, value) { // 设置域名后缀
    state.suffix = value
  },
  setlinkFriend (state, value) { // 友情链接
    state.linkFriend = [...value]
  },
  setPartnerList (state, value) { // 战略合作
    state.partnerList = [...value]
  },
  setPluginShow (state, value) { // 更新chrome下载框显示状态
    state.pluginShow = value
  },
  loginClose (state, value) { // 切换登录框显示状态
    state.loginShow = value
  },
  setfootCountry (state, value) { // 设置底部国家
    state.footCountry = [...value]
  },
  setcookieHost (state, value) { // 处理好存cookie需要的路径域名.wikifxen.com
    const host1 = ['fxeye688.com', 'fxeye.com', 'fxeyevn.com', 'fxeyevi.com', 'fxeye555.com', 'fxeye2021.com', 'fxeyefx.com', 'fxeyevps.com', 'wikifx.hk'] // 普通fxeye域名
    const host2 = ['wikifxtips.com', 'wikifx25.com', 'fxeye25.com', 'fxeyevip.com', 'fxeyetips.com', 'fxeyema.com', 'fxeyeka.com', 'wikifxvn.com', 'fxeyecn.com', 'wikifxvi.com', 'wikifxen.com', 'wikifxzh.com', 'wikifxka.com', 'wikifxcn.com'] // 特殊wikifx域名
    const host3 = ['fxeye110.com', 'fxeye123.com', 'fxeye2017.com', 'fxeye777.com'] // 特殊fxeye域名[推广]
    const host4 = ['wikifx.com', 'wikifx2.com'] // wikifx域名
    state.cookieHost = value
    // value = 'www.wikifx.com'
    let urlBool = ''
    if (!value.includes('.') || value.includes('localhost') || value.includes('127.0.0.1') || value.includes('192.168.1.')) {
      urlBool = value
    } else if (value.split('.').length <= 2) {
      urlBool = value.split('.')[0] + '.' + value.split('.')[1]
    } else if (value.split('.').length >= 3) {
      if (value.includes('.com.cn')) {
        urlBool = value.split('.')[1] + '.' + value.split('.')[2] + '.' + value.split('.')[3]
      } else {
        urlBool = value.split('.')[1] + '.' + value.split('.')[2]
      }
    }
    if (host4.includes(urlBool)) {
      state.isWiki = '1'
    }
    if (host1.includes(urlBool)) { // 包含fxeye
      state.isWiki = '2'
    }
    if (host2.includes(urlBool)) { // wikifxvn.com,wikifxvi.com,wikifxen.com
      state.isWiki = '3'
    }
    if (host3.includes(urlBool)) { // 是否是特殊的fxeye域名
      state.isWiki = '4'
    }
  },
  setConfigure (state, value) { // 首页配置
    state.indexConfigure = [...value]
  },
  setContactinfo (state, value) { // 底部联系方式
    state.contactinfo = value
  },
  setMenu (state, value) { // 设置菜单数据
    state.menuData = [...value]
  },
  setUCookie (state, value) { // 存储用户信息
    state.cookieVal = value
  },
  setUserInfo (state, value) { // 存储用户信息
    state.userInfo = value
  },
  setRisk (state, value) { // 设置风险提示
    state.riskShow = value
  },
  setPath (state, value) { // 设置当前页面路径（不包含语言）
    state.path = value
  },
  setUser (state, value) { // 设置用户信息
    state.user = Object.assign({}, value)
    // state.liveuserInfo.userId = 'web_' + (value.userId ? '1_' : '0_') + (value.userId ? value.userId : Cookie.get('wiki-bfp')) + '_' + (Math.floor(Math.random() * 1000000))
  },
  setuserCountry (state, value) { // 用户中心国家数据
    state.usergetCountry = Object.assign({}, value)
  },
  setUsercookie (state, value) { // 获取用户登录cookie
    state.contentcookie = value
  },
  setMobile (state, value) { // 设置移动端还是pc端
    state.mobile = value
  },
  setInfo (state, value) { // 获取国家code，国家名称，国家代码，国旗
    state.getCountry = Object.assign({}, value)
  },
  getIp (state, value) { // 获取用户ip
    state.userIp = value
  },
  setHostend (state, value) { // 设置域名后缀
    state.host = value
  },
  setAllhost (state, value) { // 获取当前页面地址
    state.allHost = value.replace(':443', '')
  },
  // 存储用户所在的国家
  setMyCountry (state, value) {
    if (!value.myCountry) return false
    state.myCountry = value.myCountry?.toLowerCase()
    this.$cookies.set('CURRIPCOUNTRY', value.myCountry?.toLowerCase(), { path: '/', domain: state.cookieHost })
  },
  // 存储交易商详情页origin--cookie
  setorigin (state, value) {
    this.$cookies.set('origin', value, { path: '/', domain: state.cookieHost })
  },
  // 设置语言code
  setLangCode (state, value) {
    const lang = value.lang.toLowerCase()
    state.LanguageCode = (state.langList.includes(lang) ? lang : 'en')
    this.$cookies.set('LanguageCode', state.LanguageCode, { path: '/', domain: state.cookieHost })
  },
  // 设置国家code
  setCountryCode (state, value) {
    state.CountryCode = value.country && value.country.toLowerCase()
    this.$cookies.set('CountryCode', value.country && value.country.toLowerCase(), { path: '/', domain: state.cookieHost })
  },
  updateMsgList (state, payload) { // IM消息过滤渲染
    const { chatType, chatId, msg, bySelf, type, mid, status } = payload
    if (payload.isHistory) {
      // 拿到该key已经存在的消息。
      const nowKeyMsg = state.msgList[chatType][chatId]
      // 开始筛选，如果payload.mid 不等于item.id则说明msgList中没有存储。
      const newHistoryMsg =
      nowKeyMsg &&
      nowKeyMsg.filter((item) => {
        return item.mid != payload.mid
      })
      state.msgList[chatType][chatId] = newHistoryMsg
    }
    if (!state.msgList[chatType][chatId]) {
      state.msgList[chatType][chatId] = [
        {
          msg,
          bySelf,
          type: type || '',
          mid,
          status,
          ...payload
        }
      ]
    } else {
      state.msgList[chatType][chatId].push({
        msg,
        bySelf,
        type: type || '',
        mid,
        status,
        ...payload
      })
      state.msgList[chatType][chatId] = state.msgList[chatType][chatId].sort(
        (a, b) => {
          return a.time - b.time
        }
      )
    }
    if (chatType === 'chatroom' && !bySelf) {
    // 聊天室消息去重处理
      state.currentMsgs = _.uniqBy(state.msgList[chatType][chatId], 'mid')
    } else {
      state.currentMsgs = Object.assign({}, state.msgList[chatType][chatId]) // 这里params.id在路由跳转的时候会undefind，取chatId兼容
    }
    state.msgList = Object.assign({}, state.msgList)
    // state.msg_text = '' // 消息清空
    // this.$nextTick(() => {
    //   this.html_scroll()
    // })
  },
  set_msg (state, param) {
    state.msgList = param.arr
    state.msgList = Object.assign({}, state.msgList)
  },
  // 设置当前浏览器是否支持 webRTC
  SET_IS_SUPPORT_WEBRTC (state, value) {
    state.isSupportWebRTC = value
  },
  // 更新播放线路
  UPDATE_LINE_TYPE (state, value) {
    state.lineType = value
  },
  // 更新音量大小
  UPDATE_AUDIO_LEVEL (state, value) {
    state.audioLevel = value
  },
  // 更新流播放状态
  UPDATE_PLAY_STATE (state, value) {
    state.playState = value
  },
  // 更新横竖屏
  UPDATE_LAYOUT (state, value) {
    state.layout = value
  },
  // 设置userSig
  SET_USER_SIG (state, value) {
    state.userSig = value
  },
  // 更新直播间ID
  SET_ROOM_ID (state, value) {
    state.roomId = value
  },
  // 更新直播间昵称
  SET_ROOM_NAME (state, value) {
    state.roomName = value
  },
  // 设置主播用户ID
  SET_ANCHOR_USER_ID (state, data) {
    state.anchorUserId = data
  },
  set_lang_speak_lang (state, locale) {
    // 设置字幕语言
    state.lang_speak_lang = locale
  },
  set_lang_speak (state, locale) {
    // 设置字幕
    console.log(locale, 9998866)
    state.lang_speak = locale
  }
}

export const actions = {
  nuxtServerInit ({ commit }, { req }) {
    if (!req.headers || !req.headers?.cookie) return false // 若没有cookie时，不执行后续操作
    const [myCook] = [
      this.$cookies.get('DJkdikKMG') || this.$cookies.get('ViLartidlakd') || this.$cookies.get('WsdsfgDGdagYms') || ''
    ]
    commit('setUsercookie', myCook)
  }
}
